// export default () => ({
// })

export default () => ({
    places: [],
    placesSelectable: [],
    placesPaginatedData: null,
    place: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})